/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

const CustomDemoVideo = (): JSX.Element => (
    <div style={{ width: '100%', margin: '0 auto' }}>
        <video
            src='https://boost-assets.s3.us-east-1.amazonaws.com/250414_BOOST_SIZZLE_V3.mp4'
            controls
            style={{ width: '100%', height: 'auto' }}
        />
    </div>
);

export default CustomDemoVideo;
